'use client'

import { useAsset } from '@marketplace-web/shared/assets'
import { PrivacyCardModel } from '@marketplace-web/user-agreements/privacy-center-data'

const usePrivacyAtGlanceCardContent = () => {
  const asset = useAsset('/assets/privacy-center/at-glance-section')

  const cardKeepMinimalImage = asset('IllustrationKeepMinimal.png')
  const cardYourDataImage = asset('IllustrationYourChoises.png')
  const cardDataSafetyImage = asset('IllustrationDataSafety.png')

  const atGlanceSectionCards: Array<PrivacyCardModel> = [
    {
      imageSrc: cardYourDataImage,
      title: 'privacy_center.at_glance_cards.your_data.title',
      description: 'privacy_center.at_glance_cards.your_data.description',
      link: 'privacy_center.at_glance_cards.your_data.link',
      link_a11y: 'privacy_center.at_glance_cards.your_data.link_a11y',
    },
    {
      imageSrc: cardDataSafetyImage,
      title: 'privacy_center.at_glance_cards.data_safety.title',
      description: 'privacy_center.at_glance_cards.data_safety.description',
      link: 'privacy_center.at_glance_cards.data_safety.link',
      link_a11y: 'privacy_center.at_glance_cards.data_safety.link_a11y',
    },
    {
      imageSrc: cardKeepMinimalImage,
      title: 'privacy_center.at_glance_cards.keep_minimal.title',
      description: 'privacy_center.at_glance_cards.keep_minimal.description',
      link: 'privacy_center.at_glance_cards.keep_minimal.link',
      link_a11y: 'privacy_center.at_glance_cards.keep_minimal.link_a11y',
    },
  ]

  return atGlanceSectionCards
}

export default usePrivacyAtGlanceCardContent
